var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jz-container',{staticClass:"single-sentence-reading-toast-container",class:{ show: _vm.show }},[_c('jz-card',{staticClass:"single-sentence-reading-toast"},[_vm._v(" 全問答えると、最後にくわしい評価結果を見ることができます。 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }